export default "__VITE_ASSET__CNr_X_RE__"